import { Environments } from '@/config';
import { HELIX_WAKEMED_PRODUCTION } from './helix-wakemed.production';
import { HELIX_WAKEMED_STAGING } from './helix-wakemed.staging';

export const HELIX_WAKEMED =
  import.meta.env.MODE === Environments.PROD ? HELIX_WAKEMED_PRODUCTION : HELIX_WAKEMED_STAGING;
